import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#060b1a] text-white flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="text-center max-w-md">
        <h1 className="font-display text-3xl font-extrabold">No worries — nothing was charged.</h1>
        <p className="text-slate-400 mt-3">You can pick a plan whenever you're ready. Your work stays safe in the meantime.</p>
        <Button className="mt-7 h-11 px-7 gap-2" onClick={() => nav("/pricing")} data-testid="payment-cancel-pricing"><ArrowLeft className="h-4 w-4" /> Back to pricing</Button>
      </div>
    </div>
  );
}
